import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { LoginPage } from './pages/LoginPage'
import { ForgotPasswordPage } from './pages/ForgotPasswordPage'
import { ProfilePage } from './pages/ProfilePage'
import { SettingsPage } from './pages/SettingsPage'
import { UserEditorPage } from './pages/UserEditorPage'
import { useAuthStore } from './hooks/useAuth'
import './App.css'

function App() {
  const { isAuthenticated, isLoading, user, checkAuth } = useAuthStore()

  useEffect(() => {
    checkAuth()
  }, [])

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-end p-4 pr-8 md:pr-16 lg:pr-24">
      <Routes>
        <Route
          path="/"
          element={<Navigate to={isAuthenticated ? '/profile' : '/login'} replace />}
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route
          path="/profile"
          element={isAuthenticated ? <ProfilePage /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/settings"
          element={
            !isAuthenticated ? <Navigate to="/login" replace /> :
            user?.isAdmin ? <SettingsPage /> :
            <Navigate to="/profile" replace />
          }
        />
        <Route
          path="/settings/users/:sub"
          element={
            !isAuthenticated ? <Navigate to="/login" replace /> :
            user?.isAdmin ? <UserEditorPage /> :
            <Navigate to="/profile" replace />
          }
        />
        <Route path="/callback" element={<CallbackHandler />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  )
}

function CallbackHandler() {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')
    const error = urlParams.get('error')

    if (error || !code) {
      window.location.href = '/login'
      return
    }

    fetch('/api/auth/callback', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code }),
      credentials: 'include',
    })
      .then(res => { window.location.href = res.ok ? '/profile' : '/login' })
      .catch(() => { window.location.href = '/login' })
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-white text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white mx-auto mb-4" />
        <p>Processing login…</p>
      </div>
    </div>
  )
}

export default App
